import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useAuthSession } from "@/hooks/use-auth-session"
import { cn } from "@/lib/utils"
import { getMobileTabItems } from "./nav-config"

// Aligns with SiteHeader app primary links via nav-config.
// Guests keep Tap-In + Account instead of Create / My Events so they are not
// dropped into marketing chrome from the app shell.
export function MobileNav() {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const { isAuthenticated } = useAuthSession()

  const items = getMobileTabItems(isAuthenticated).map((item) => ({
    ...item,
    to: item.key === "account" && isAuthenticated ? "/profile" : item.path,
    label: t(item.labelKey, {
      defaultValue: item.labelFallback ?? item.labelKey,
    }),
  }))

  return (
    <nav
      aria-label={t("nav.mainNavigation", { defaultValue: "Primary" })}
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/80 backdrop-blur-xl backdrop-saturate-150 md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <ul className="grid grid-cols-5">
        {items.map((item) => {
          const active = item.match(pathname)
          const Icon = item.icon
          return (
            <li key={item.key}>
              <Link
                to={item.to}
                aria-label={item.label}
                aria-current={active ? "page" : undefined}
                className="flex min-h-[49px] flex-col items-center justify-center gap-0.5 px-1 pb-1.5 pt-2 transition-opacity duration-100 active:opacity-60"
              >
                <Icon
                  className={cn(
                    "h-[26px] w-[26px] transition-colors duration-150",
                    active
                      ? "fill-primary/10 text-primary"
                      : "text-muted-foreground",
                  )}
                  strokeWidth={active ? 2.1 : 1.7}
                  aria-hidden
                />
                <span
                  className={cn(
                    "text-[10px] font-medium leading-[12px] tracking-tight transition-colors duration-150",
                    active ? "text-primary" : "text-muted-foreground",
                  )}
                >
                  {item.label}
                </span>
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
